import type { HTMLAttributes, ReactNode } from "react";

import { BRAND_SHELLS } from "@/brands";
import { BrandShell } from "@/brands/base/BrandShell";
import { cn } from "@/lib/utils";
import { getActiveBrand } from "@/utils/theme/brand";

export interface ULThemePageLayoutProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The content of the layout.
   */
  children: ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
}

const ULThemePageLayout = ({
  children,
  className,
  ...rest
}: ULThemePageLayoutProps) => {
  // Brand shells are opt-in per Auth0 client via ClientTheme.brand; the theme
  // engine stamps <html data-ul-brand> before any screen renders its layout.
  const brand = getActiveBrand();
  if (brand) {
    // All screens pass only className; ...rest is intentionally not forwarded to the shell.
    return (
      <BrandShell config={BRAND_SHELLS[brand]} className={className}>
        {children}
      </BrandShell>
    );
  }

  const themedStyles =
    "flex items-start md:items-center min-h-screen w-full max-w-[100vw] overflow-x-hidden px-4 py-6 md:px-10 md:py-20 justify-page-layout bg-(color:--ul-theme-page-bg-background-color) bg-(image:--ul-theme-page-bg-background-image-url)";
  return (
    <div className={cn(themedStyles, className)} {...rest}>
      {children}
    </div>
  );
};

export default ULThemePageLayout;
